import axios from "axios";
import {BASIC_QUERY, EXTERNAL_API_QUERY, GET_ALL_EDUCATION, GET_ALL_EXPERIENCE} from "./RestCatalog";


const submitBasicQuery = (query) => {
    return axios.post(BASIC_QUERY, query)
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const submitExternalAPIQuery = (query) => {
    return axios.post(EXTERNAL_API_QUERY, query)
        .then((response) => response.data)
        .catch((e) => console.error(e));
};

const getUsersEducation = () => {
    return axios.get(GET_ALL_EDUCATION)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

const getUsersExperience = () => {
    return axios.get(GET_ALL_EXPERIENCE)
        .then((response) => response.data)
        .catch((e) => console.error(e));
}

export {
  submitBasicQuery,
  submitExternalAPIQuery,
  getUsersEducation,
  getUsersExperience,
};
